/**
 * Configuration
 * @module config
 */

const config = {
  name: 'Arrow',
  description: 'Project Management',
};

export default config;
